<div
  [attr.data-toast-container-id]="'container-' + instanceId()"
  class="absolute flex w-full p-4 transition-all duration-150 ease-in-out"
  [ngClass]="containerClasses()"
  [ngStyle]="{
    transform: 'translateY(' + offsetFromSibling() + 'px' + ')'
  }"
>
  <div
    data-cid="toast"
    [attr.data-toast-id]="id()"
    [attr.role]="'alert'"
    [attr.aria-live]="'assertive'"
    [attr.aria-atomic]="'true'"
    [attr.aria-describedby]="'toast-message-' + id()"
    class="pointer-events-auto w-fit max-w-md overflow-hidden rounded-lg border px-4 py-2 shadow-lg transition-all duration-300"
    [ngClass]="combinedClasses()"
    [@toastState]="toastAnimationState()"
  >
    <div class="relative text-neutral-low-dark">
      <div
        class="flex items-start justify-start gap-3"
        [ngClass]="{
          'pr-7': dismissible()
        }"
      >
        @if (showIcon()) {
          @if (icon(); as icon) {
            <ng-icon
              [name]="icon"
              size="20"
              strokeWidth="2.5"
              [ngClass]="{
                'text-white [&>*]:text-white':
                  variant() === 'success' ||
                  variant() === 'danger' ||
                  variant() === 'info',
                'text-black [&>*]:text-black': variant() === 'warning'
              }"
            />
          }
        }
        <div
          class="flex-1 overflow-y-auto pr-1 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-current scrollbar-track-rounded-lg scrollbar-thumb-rounded-lg"
          [ngClass]="{
            'text-white':
              variant() === 'success' ||
              variant() === 'danger' ||
              variant() === 'info',
            'text-black': variant() === 'warning'
          }"
        >
          <div
            [innerHTML]="toastHTML()"
            class="max-h-32 space-y-4 text-sm/normal font-medium text-current [&>*]:text-sm/normal [&>*]:font-medium [&>*]:text-current [&_a]:font-medium [&_a]:text-brand-primary-pure [&_a]:underline [&_a]:underline-offset-2 [&_a]:transition-colors [&_a]:duration-150 [&_a]:ease-in-out [&_a]:hover:text-brand-primary-dark first:[&_li]:mt-3 [&:not(first-child)]:[&_li]:mt-1.5 [&_ol]:list-inside [&_ol]:list-decimal [&_ol]:pl-4 [&_ul]:list-inside [&_ul]:list-disc [&_ul]:pl-4"
          ></div>
        </div>
      </div>
      @if (dismissible()) {
        <button
          (click)="close(true)"
          class="absolute inset-y-0 right-0 flex h-fit items-stretch justify-center rounded-full p-0.5 transition-all duration-75 hover:bg-white/10 hover:brightness-95 active:scale-90"
          [ngClass]="{
            'text-white': variant() !== 'warning',
            'text-black': variant() === 'warning'
          }"
        >
          <ng-icon name="featherX" strokeWidth="2.5" size="18" />
        </button>
      }
    </div>
  </div>
</div>
